<!--
     <TextareaInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - size
     - value
     - label
     - placeholder
-->

<template>
  <v-textarea
    v-model="props.value"
    auto-grow
    :label="props.label"
    :size="props.size"
    :placeholder="props.placeholder"
    :readonly="!!props.readonly"
    :rules="rules"
    @error="error_state"
    :class="[props.class || 'qmkey-form-input', {'required':props.required}]"
    outlined
    dense
    background-color="#f2f2f2"
  ></v-textarea>
</template>


<script>
 export default {
   name: 'TextareaInput',

   props: ['props'],

   data: (() => ({
     valid: true,
   })),

   computed: {
     value() {
       return this.props.value;
     },
     rules() {
       // TODO: Multilang: Change hardcoded string
       return [
         value => !!value || !this.props.required || 'Campo requerido'         
       ];
     }
   },

  //  mounted() {
  //    this.rules.push( // Defined here to have acces to /this/
  //      (value) => !this.props.required || !!value || 'Campo requerido'
  //    );
  //  },

   methods: {
     validate() {
       return this.valid;
     },

     error_state(ok) {
       this.valid = ok;
     },
   },
 }
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>